<template>
  <b-row>
    <b-col
      :cols="12"
      class="d-flex align-items-center"
    >
      <font-awesome-icon
        icon="gift"
        size="2x"
        class="fa-fw"
      />
      <span class="pl-3">
        <template v-if="gameType === 'summer'">
          {{ $t('quests.makeRoster.summer.info.1', { x: 5 }) }}
        </template>
        <template v-else>
          {{ $t('quests.makeRoster.play-at-least') }}
          <span :class="$style.orange">{{ $t('quests.makeRoster.x-rounds-on-pick8', { x: 5 }) }}</span>
          {{ $t('quests.makeRoster.and-qualify-for-a-chance-to-win-a') }}
          <span :class="$style.orange">
            {{ $t('quests.makeRoster.unique-vip-experience') }}
          </span>
        </template>
      </span>
    </b-col>

    <b-col
      :cols="12"
      class="d-flex align-items-center pt-3"
    >
      <font-awesome-icon
        :icon="gameType === 'summer' ? 'trophy' : 'plane'"
        size="2x"
        class="fa-fw"
      />
      <span class="pl-3">
        <template v-if="gameType === 'summer'">
          {{ $t('quests.makeRoster.summer.info.2') }}
        </template>
        <template v-else>
          <span :class="$style.orange">{{ $t('quests.makeRoster.x-lucky-members', { x: 2 }) }}</span>
          {{ $t('quests.makeRoster.will-be-invited-to') }}
          <span :class="$style.orange">{{ $t('quests.makeRoster.watch-an-epl-match-live-in-the-uk') }}</span>
          {{ $t('quests.makeRoster.all-expenses-paid') }}
        </template>
      </span>
    </b-col>

    <b-col
      :cols="12"
      class="d-flex align-items-center pt-3"
    >
      <font-awesome-icon
        icon="bell"
        size="2x"
        class="fa-fw"
      />
      <span class="pl-3">
        <template v-if="gameType === 'summer'">
          {{ $t('quests.makeRoster.summer.info.3') }}
        </template>
        <template v-else>
          {{ $t('quests.makeRoster.winners-will-be') }}
          <span :class="$style.orange">{{ $t('quests.makeRoster.announced-on-pick8') }}</span>
          {{ $t('quests.makeRoster.stay-tuned-to-find-out-if-you-are') }}
          <span :class="$style.orange">{{ $t('quests.makeRoster.one-of-them') }}</span>
        </template>
      </span>
    </b-col>

    <b-col
      :cols="12"
      class="d-flex align-items-center pt-3"
    >
      <font-awesome-icon
        icon="gamepad"
        size="2x"
        class="fa-fw"
      />
      <span class="pl-3">
        <template v-if="gameType === 'summer'">
          {{ $t('quests.makeRoster.summer.info.4') }}
        </template>
        <template v-else>
          <span :class="$style.orange">{{ $t('quests.makeRoster.remember') }}</span>
          {{ $t('quests.makeRoster.the-more-rounds-you-play-the-more-chances-to-win') }}
        </template>
      </span>
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'QuestInfo',
  computed: {
    ...mapState({
      gameType: state => state['game/type'].type,
    }),
  },
}
</script>

<style module lang="scss">
  @import "../../../../assets/scss/variables";
  .orange {
    color: $color-tomato;
  }
</style>
